import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Search, X } from "lucide-react";
import React from "react";
import { Card, CardBody, Container } from "react-bootstrap";

export const Orders: React.FC = () => {

    return(
        <React.Fragment>
          
            <Container fluid className="p-0">
                 <Card>
                   <Card.Header style={{ padding: '15px 0px 0px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                      <Card.Title>Orders</Card.Title>
                    </div>
                  </Card.Header>
                  <CardBody>
                          <div>
                            <div style={{ width: '100%',  padding: '4px 8px', backgroundColor: 'white' }}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row gap-2" style={{marginTop: '14px'}}>
                                            <h6 className="card-subtitle text-muted">Total Records: {0} </h6> 
                                            <h6 className="card-subtitle text-muted">Current Page :  [{ 0 } of {0}]</h6> 
                                        </div>

                                        <div className="d-flex align-items-center gap-3">
                                            {/* // Page Size */}
                                            <nav aria-label="">
                                                <ul className="pagination m-0">
                                                    <li className="page-item">
                                                        <select className="page-link" 
                                                            // value={pageSize}
                                                            // onChange={handlePageSizeChange}
                                                            style={{width: '100px', textAlign: 'center', padding: '10px'}}>
                                                            <option defaultChecked ></option>
                                                            {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
                                                              <option key={size} value={size}>{size}</option>
                                                            ))}
                                                        </select>
                                                    </li>                            
                                                </ul>
                                            </nav>

                                            {/* // Pagination Control */}
                                            <nav aria-label="">
                                              <ul className="pagination m-0">
                                                <li className={`page-item disabled `}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center gap-1"
                                                    // onClick={goToFirstPage}
                                                    disabled={true}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronsLeft size={18} />
                                                  </button>
                                                </li>

                                                <li className={`page-item  disabled`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    // onClick={goToPreviousPage}
                                                    disabled={true}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronLeft size={18} />
                                                  </button>
                                                </li>

                                                <li className="page-item">
                                                  <span
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    style={{ height: '38px', marginTop: '1px', padding: '0 14px' }}
                                                  >
                                                    Page {0} of {0}
                                                  </span>
                                                </li>

                                                <li className={`page-item disabled`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    // onClick={goToNextPage}
                                                    disabled={true}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronRight size={18} />
                                                  </button>
                                                </li>

                                                <li className={`page-item disabled `}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center gap-1"
                                                    // onClick={goToLastPage}
                                                    disabled={true}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronsRight size={18} />
                                                  </button>
                                                </li>
                                              </ul>
                                            </nav>
                                      </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                            <table className="table table-md table-hover-light w-100 mb-0">
                                {/* FILTER INPUTS HEADER */}
                                {/* <thead>
                                  <tr>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}>----</th> 
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}>----</th>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}>----</th>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}>----</th>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}>----</th>
                                    <th style={{ backgroundColor: 'white', padding: '4px 8px', width:'120px' }}>
                                        <div className="d-flex justify-content-end gap-1 w-100">
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-md d-flex justify-content-center align-items-center"
                                            // onClick={searchClicked}
                                          >
                                            <Search style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-md d-flex justify-content-center align-items-center"
                                            // onClick={clearSearchClicked}
                                          >
                                            <X style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                        </div>
                                      </th>
                                  </tr>
                                </thead>
                                <thead>
                                <tr>
                                  <th
                                    style={{
                                      fontWeight: "600",
                                      backgroundColor: "white",
                                      border: 'none',
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "40px", // Set a consistent height for the checkbox
                                    }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                    //   checked={currentPageIds.length > 0 && allCurrentPageSelected}
                                    //   onChange={handleToggleAll}
                                    />
                                  </th>
                                     {[
                                       {key: "1", label: "----"}, 
                                       {key: "2", label: "----"}, 
                                       {key: "3", label: "----"}, 
                                       {key: "4", label: "----"}, 
                                       {key: "5", label: "----"},
                                     ].map(({ key, label }, index) => (
                                    <th
                                      key={key}
                                      style={{
                                        fontWeight: "600",
                                        backgroundColor: "white",
                                        paddingLeft: "20px",
                                        height: "40px", // Make sure all header cells have the same height
                                        ...(index === [
                                       {key: "1", label: "----"}, 
                                       {key: "2", label: "----"}, 
                                       {key: "3", label: "----"}, 
                                       {key: "4", label: "----"}, 
                                       {key: "5", label: "----"},
                                     ].length - 1 && { borderRight: "1px solid #deebed" }),
                                      }}
                                    >
                                      {label}
                                    </th>
                                  ))}
                                 
                                </tr>
                               </thead> */}
                                
                                  <thead>
                                    <tr>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th> 
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                      
                                        <td style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                            <input type="text" autoComplete="off"  className="form-control form-control-md" />
                                        </td>
                                          <td style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                            <input type="text" autoComplete="off"  className="form-control form-control-md" />
                                        </td>
                                          <td style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                            <input type="text" autoComplete="off"  className="form-control form-control-md" />
                                        </td>
                                          <td style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                            <input type="text" autoComplete="off"  className="form-control form-control-md" />
                                        </td>
                                          <td style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                            <input type="text" autoComplete="off"  className="form-control form-control-md" />
                                        </td>
                                   
                                    <th style={{ backgroundColor: 'white', padding: '4px 8px', width:'120px' }}>
                                            <div className="d-flex justify-content-end gap-1 w-100">
                                            <button
                                            type="button"
                                            className="btn btn-outline-danger btn-md d-flex justify-content-center align-items-center"
                                            // onClick={searchClicked}
                                            >
                                            <Search style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                            </button>
                                            <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-md d-flex justify-content-center align-items-center"
                                            // onClick={clearSearchClicked}
                                            >
                                            <X style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                            </button>
                                        </div>
                                    </th>
                                    </tr>
                                </thead>
                                <thead>
                                <tr>
                                    <td
                                    style={{
                                        fontWeight: "600",
                                        backgroundColor: "white",
                                        border: 'none',
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "40px", // Set a consistent height for the checkbox
                                    }}
                                    >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        // checked={currentPageIds.length > 0 && allCurrentPageSelected}
                                        // onChange={handleToggleAll}
                                    />
                                    </td>
                                   
                                </tr>
                            </thead>
                                <tbody>
                              
                                </tbody>
                              </table>
                              </div>
                            </div>
                  </CardBody>
                </Card>
           
            </Container>
        </React.Fragment>
    );
}